module.exports = __webpack_public_path__ + "static/media/sports_6.d66bd33a.jpg";